<template>
  <span
    v-if="dsComponentDetails.version === VersionOptions.LEGACY"
    class="sb-chip"
  >
    <!--
    @slot text, components, or HtmlElements as children of the component
  -->
    <slot />
    <i
      v-if="dismissable"
      aria-hidden="true"
      class="sb-chip__dismiss sb-icon-x"
      @click.prevent="$emit('close')"
    />
  </span>
  <SbChipNext
    v-else
    v-bind="$attrs"
    :dismissable="dismissable"
    @close="$emit('close')"
  >
    <slot />
  </SbChipNext>
</template>
<script>
import { versionedComponentsMixin } from '@src/mixins/versionedComponents';
import SbChipNext from '@src/components/Chip/SbChipNext.vue';

export default {
  name: 'SbChip',
  components: {
    SbChipNext,
  },
  mixins: [versionedComponentsMixin],
  props: {
    /**
     * If the banner can be closed.
     */
    dismissable: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    /**
    * Emitted when the close button is clicked.
    * @param {bool} value
    */
    'close',
  ],
};
</script>
<style lang="scss" scoped>
@import '@src/components/Chip/style/sb-chip.scss';
</style>
